module.exports = __webpack_public_path__ + "static/media/Logo Mitur Final.10beec6e.png";